<template>
    <v-container fluid>
        <period-selector v-if="$vuetify.breakpoint.mdAndDown"></period-selector>

        <v-row justify="center">
            <template v-if="periods === null">
                <v-col
                    v-for="i in 2"
                    :key="i"
                    xs="12"
                    sm="6"
                    md="5"
                    lg="3"
                >
                    <v-skeleton-loader type="image"></v-skeleton-loader>
                </v-col>
            </template>

            <div
                v-else-if="periods.length === 0"
                class="text-center mt-8"
            >
                Terima kasih :)
                <br />
                Kamu sudah mendaftar semua periode tryout yang tersedia.
                <br />
                Tetap tunggu tryout baru dari Ukom Nakes!
                <br />
            </div>

            <price-item
                v-else
                v-for="period in periods"
                @register="enroll(period)"
                :key="period.id"
                :price="period"
            ></price-item>
        </v-row>

        <enrollment-confirmation
            v-model="confirmationDialog"
            :period="selectedPeriod"
        ></enrollment-confirmation>
    </v-container>
</template>

<script>
import PeriodSelector from '@/components/dashboard/period/PeriodSelector'
import PriceItem from '@/components/home/components/PriceItem'
import EnrollmentConfirmation from './EnrollmentConfirmation'

export default {
    components: {
        PeriodSelector,
        PriceItem,
        EnrollmentConfirmation,
    },

    data() {
        return {
            periods: null,
            confirmationDialog: null,
            selectedPeriod: {},
        }
    },

    methods: {
        enroll(period) {
            this.$tracking.event.program.click(period.title)
            this.selectedPeriod = period
            this.confirmationDialog = true
        },
    },

    created() {
        const enrolledPeriodIds = this.$store
            .get('enrollment/enrollments')
            .map((e) => e.id)

        this.$api.get('tryoutPeriod').then((response) => {
            this.periods = response.data.tryoutPeriods.filter((e) => {
                return !enrolledPeriodIds.includes(e.id)
            })
        })
    },
}
</script>
